import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { MinusIcon } from '@10xLabs/react-web/components/Icons/Minus'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { PlusIcon } from '@10xLabs/react-web/components/Icons/Plus'
import { VehicleGrid } from 'features/VehicleTemplates/components/VehicleGrid'
import { SelectComponent } from 'features/VehicleTemplates/components/SelectComponent'
import { SelectProperty } from 'features/VehicleTemplates/components/SelectProperty'
import { createEmptyRow } from 'features/VehicleTemplates/components/NewVehicleTemplate'
import { VEHICLE_COMPONENT } from 'features/VehicleTemplates/components/Components/constants'
import { SEAT_NUMBERING } from 'features/VehicleTemplates/components/SeatNumbering/constants'
import { pad2 } from 'utils/string'

const FIRST_FLOOR_INDEX = 0
const SECOND_FLOOR_INDEX = 1

const Wrapper = styled.div<TSFixMe>`
  min-height: 400px;
`

const FloorController = styled.div<TSFixMe>`
  margin-bottom: 5px;
`

const Floors = styled.div<TSFixMe>`
  margin-top: 20px;
  display: flex;
  align-items: center;
  width: 100%;
`

const Floor = styled.div<TSFixMe>`
  width: 0;
  flex: 1 0 auto;
  text-align: center;
  padding: 10px 0;
  background-color: ${(props): TSFixMe => (props.isActive ? '#9999bd' : '#ffffff')};
  border: 1px solid #9999bd;
  color: ${(props): TSFixMe => (props.isActive ? '#ffffff' : '#9999bd')};
  cursor: pointer;

  :first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }

  :last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`

const GridWrapper = styled.div<TSFixMe>`
  position: relative;
`

const SelectComponentWrapper = styled.div<TSFixMe>`
  position: absolute;
  top: 0;
  left: -50px;
  transform: translate(-100%, 0);
`

const SelectPropertyWrapper = styled.div<TSFixMe>`
  position: absolute;
  top: 0;
  right: -30px;
  transform: translate(100%, 0);
`

const ControllerWrapper = styled.div<TSFixMe>`
  margin: 15px 0;
`

const Controllers = styled.div<TSFixMe>`
  display: flex;
  align-items: center;
  margin: -10px -10px;
`

const Controller = styled.div<TSFixMe>`
  margin: 10px;
  font-size: 14px;
  color: ${(props): TSFixMe => (props.disabled ? '#9bccfd' : '#1976d2')};
  cursor: ${(props): TSFixMe => (props.disabled ? 'not-allowed' : 'pointer')};
  display: flex;
  align-items: center;

  svg {
    width: 18px;
    height: 18px;
    fill: ${(props): TSFixMe => (props.disabled ? '#9bccfd' : '#1976d2')};
    margin-right: 5px;
  }
`

const DEFAULT_FLOOR_INDEX = 0

const updateSeatNumberByRow = (row: TSFixMe, currentSeatNumber: TSFixMe, horizontalSeatNumbering: TSFixMe): TSFixMe => {
  let rowWithSeatNumber
  if (horizontalSeatNumbering === SEAT_NUMBERING.LEFT_TO_RIGHT) {
    rowWithSeatNumber = row.map((cell: TSFixMe): TSFixMe => {
      if (cell.component === VEHICLE_COMPONENT.SEAT) {
        currentSeatNumber += 1

        return {
          ...cell,
          label: pad2(currentSeatNumber)
        }
      }

      return cell
    })
  } else {
    rowWithSeatNumber = row.reduceRight(
      (result: TSFixMe, cell: TSFixMe, index: TSFixMe): TSFixMe => {
        if (cell.component === VEHICLE_COMPONENT.SEAT) {
          currentSeatNumber += 1

          result[index] = {
            ...cell,
            label: pad2(currentSeatNumber)
          }
        }

        return result
      },
      [...row]
    )
  }

  return {
    lastSeatNumber: currentSeatNumber,
    rowWithSeatNumber
  }
}

export const updateSeatNumber = (
  grid: TSFixMe,
  horizontalSeatNumbering: TSFixMe,
  verticalSeatNumbering: TSFixMe
): TSFixMe => {
  let currentSeatNumber = 0

  if (verticalSeatNumbering === SEAT_NUMBERING.BOTTOM_TO_TOP) {
    return grid.map((floor: TSFixMe): TSFixMe => {
      return floor.map((row: TSFixMe): TSFixMe => {
        const { lastSeatNumber, rowWithSeatNumber } = updateSeatNumberByRow(
          row,
          currentSeatNumber,
          horizontalSeatNumbering
        )
        currentSeatNumber = lastSeatNumber
        return rowWithSeatNumber
      })
    })
  } else {
    return grid.reduceRight(
      (gridResult: TSFixMe, floor: TSFixMe, floorIndex: TSFixMe): TSFixMe => {
        gridResult[floorIndex] = floor.map((row: TSFixMe): TSFixMe => {
          const { lastSeatNumber, rowWithSeatNumber } = updateSeatNumberByRow(
            row,
            currentSeatNumber,
            horizontalSeatNumbering
          )
          currentSeatNumber = lastSeatNumber
          return rowWithSeatNumber
        })

        return gridResult
      },
      [...grid]
    )
  }
}

export const VehicleGridForm = ({
  grid,
  horizontalSeatNumbering,
  verticalSeatNumbering,
  readOnly,
  ...props
}: TSFixMe): TSFixMe => {
  const [currentFloorIndex, setCurrentFloorIndex] = useState(DEFAULT_FLOOR_INDEX)
  const [selectedComponent, setSelectedComponent] = useState(VEHICLE_COMPONENT.SEAT)
  const [selectedProperty, setSelectedProperty] = useState({
    component: '',
    value: ''
  })
  const currentFloor = grid[currentFloorIndex]

  const addRowDisabled = currentFloor.length === 26
  const deleteRowDisabled = currentFloor.length === 1

  const addFloor = (): TSFixMe => {
    const columnCount = currentFloor[0].length

    const newGrid = [...grid, [createEmptyRow(columnCount)]]

    props.onChange(newGrid)
    setCurrentFloorIndex(SECOND_FLOOR_INDEX)
  }

  const deleteFloor = (): TSFixMe => {
    const newGrid = grid.slice(0, grid.length - 1)

    setCurrentFloorIndex(FIRST_FLOOR_INDEX)
    props.onChange(newGrid)
  }

  const addRow = (): TSFixMe => {
    if (!addRowDisabled) {
      const newGrid = [...grid]

      const columnCount = currentFloor[0].length
      const newFloor = [...currentFloor, createEmptyRow(columnCount)]

      newGrid[currentFloorIndex] = newFloor

      props.onChange(newGrid)
    }
  }

  const deleteRow = (): TSFixMe => {
    if (!deleteRowDisabled) {
      const newGrid = [...grid]

      const newFloor = currentFloor.slice(0, currentFloor.length - 1)

      newGrid[currentFloorIndex] = newFloor

      props.onChange(newGrid)
    }
  }

  const handleCellClick = (rowIndex: TSFixMe, cellIndex: TSFixMe): TSFixMe => {
    if (readOnly) return

    let newGrid = [...grid]
    const currentCell = newGrid[currentFloorIndex][rowIndex][cellIndex]

    if (selectedComponent) {
      const newCell = {
        component: selectedComponent,
        properties: []
      }

      newGrid[currentFloorIndex][rowIndex][cellIndex] = newCell

      newGrid = updateSeatNumber(newGrid, horizontalSeatNumbering, verticalSeatNumbering)

      props.onChange(newGrid)
    } else if (selectedProperty && selectedProperty.component === currentCell.component) {
      if (currentCell.properties.indexOf(selectedProperty.value) === -1) {
        const newCell = {
          ...currentCell,
          properties: [...currentCell.properties, selectedProperty.value]
        }

        newGrid[currentFloorIndex][rowIndex][cellIndex] = newCell

        props.onChange(newGrid)
      }
    }
  }

  const handleComponentChange = (component: TSFixMe): TSFixMe => {
    setSelectedComponent(component)
    setSelectedProperty({
      component: '',
      value: ''
    })
  }

  const handlePropertyChange = (component: TSFixMe, property: TSFixMe): TSFixMe => {
    setSelectedProperty({
      component,
      value: property
    })
    setSelectedComponent('')
  }

  const isDoubleFloor = grid.length > 1

  return (
    <Wrapper>
      <FloorController>
        {isDoubleFloor ? (
          <>
            <Floors>
              <Floor
                onClick={(): TSFixMe => setCurrentFloorIndex(FIRST_FLOOR_INDEX)}
                isActive={currentFloorIndex === FIRST_FLOOR_INDEX}
              >
                <FormattedMessage
                  id="vehicleTemplates.form.floor"
                  defaultMessage="Floor {count}"
                  values={{
                    count: 1
                  }}
                />
              </Floor>

              <Floor
                onClick={(): TSFixMe => setCurrentFloorIndex(SECOND_FLOOR_INDEX)}
                isActive={currentFloorIndex === SECOND_FLOOR_INDEX}
              >
                <FormattedMessage
                  id="vehicleTemplates.form.floor"
                  defaultMessage="Floor {count}"
                  values={{
                    count: 2
                  }}
                />
              </Floor>
            </Floors>

            {!readOnly && (
              <ControllerWrapper>
                <Controllers>
                  <Controller onClick={deleteFloor}>
                    <MinusIcon />

                    <FormattedMessage id="vehicleTemplates.form.deleteFloor" defaultMessage="Delete floor" />
                  </Controller>
                </Controllers>
              </ControllerWrapper>
            )}
          </>
        ) : (
          !readOnly && (
            <ControllerWrapper>
              <Controllers>
                <Controller onClick={addFloor}>
                  <PlusIcon />

                  <FormattedMessage id="vehicleTemplates.form.addFloor" defaultMessage="Add floor" />
                </Controller>
              </Controllers>
            </ControllerWrapper>
          )
        )}
      </FloorController>

      <GridWrapper>
        {!readOnly && (
          <SelectComponentWrapper>
            <SelectComponent selectedComponent={selectedComponent} onChange={handleComponentChange} />
          </SelectComponentWrapper>
        )}

        <VehicleGrid grid={currentFloor} onClick={handleCellClick} />

        {!readOnly && (
          <SelectPropertyWrapper>
            <SelectProperty selectedProperty={selectedProperty} onChange={handlePropertyChange} />
          </SelectPropertyWrapper>
        )}
      </GridWrapper>

      {!readOnly && (
        <ControllerWrapper>
          <Controllers>
            <Controller onClick={addRow} disabled={addRowDisabled}>
              <PlusIcon />

              <FormattedMessage id="vehicleTemplates.form.addRow" defaultMessage="Add row" />
            </Controller>

            <Controller onClick={deleteRow} disabled={deleteRowDisabled}>
              <MinusIcon />

              <FormattedMessage id="vehicleTemplates.form.deleteRow" defaultMessage="Delete row" />
            </Controller>
          </Controllers>
        </ControllerWrapper>
      )}
    </Wrapper>
  )
}
